import React, { Component } from 'react';
import { defaultTo, isEmpty, path, reduce } from 'ramda';

import styles from './styles.m.scss';

import magic from '../../../../../util/magic';
import { addPrices, toCurrency, getDiscountFromLineItems } from '../../../../../util/helpers';
import { apiProcessPayment } from '../../../../../api/registration';
import { handleErrorBase, handleSuccessBase } from '../../../../../util/forms';

import Footer from '../../../../../components/Accordion/Footer';
import DiscountForm from '../../../../../components/DiscountForm';
import FormGroup from '../../../../../components/Forms/FormGroup';
import { apiUpdateRegistration } from '../../../../../api/registration';
import StripeCheckout from '../../../../../components/StripeCheckout/index';
import FinalPrice from './Components/FinalPrice';

class PathwaySummary extends Component {
  render() {
    const { name, setStep, step, certification, registration, updateRegistration } = this.props;
    if (isEmpty(registration)) return <noscript />;

    const fees = defaultTo([], registration.registrationFees);
    const discount = getDiscountFromLineItems(fees);
    const totalPrices = reduce(addPrices, { total: 0, afterDiscount: 0 }, [...fees]);
    const finishedWithStep = registration.step != magic.pathwayApprovalStep && totalPrices.afterDiscount == 0;

    return (
      <div>
        <h2 className={styles.stepHeader}>Please review your information</h2>
        <FormGroup label="Registration Details">
          <p>
            <strong>Certification:</strong> {certification.name}
          </p>
          <p>
            <strong>Registration Type:</strong> {path(['pathway', 'name'], registration)}
          </p>
        </FormGroup>
        <DiscountForm
          discount={discount}
          checkDiscount={(discountCode) => apiUpdateRegistration(registration.id, { discountCode })}
          update={(registration) => updateRegistration(registration)}
        />
        <FormGroup label="Total Due">
          <table className="table">
            <thead>
              <tr>
                <th>Description</th>
                <th>Price</th>
                <th>Discount</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {fees.map((fee) => (
                <tr key={fee.id}>
                  <th>{fee.name}</th>
                  <td>{toCurrency(fee.price)}</td>
                  <td>{discount.registrationFee && discount.percentage && `-${discount.amount}%`}</td>
                  <td>
                    <FinalPrice lineItem={fee} readonly />
                  </td>
                </tr>
              ))}
              <tr>
                <th>Total</th>
                <td>{toCurrency(totalPrices.total)}</td>
                <td>{!isEmpty(discount) && !discount.percentage && `-${toCurrency(discount.amount)}`}</td>
                <td>{toCurrency(totalPrices.afterDiscount)}</td>
              </tr>
            </tbody>
          </table>
        </FormGroup>
        <Footer
          step={step}
          setStep={setStep}
          finishBtn={() => {
            if (finishedWithStep) {
              return (
                <button className="btn btn-primary" onClick={() => setStep(step + 1)}>
                  Next
                </button>
              );
            }

            return (
              <StripeCheckout
                name="Sage Financial Solutions"
                description="Registration Payment"
                amount={Number(totalPrices.afterDiscount)}
                pay={(token, overrides = {}) =>
                  apiProcessPayment(registration.id, { stepName: name, token, ...overrides })
                    .then(({ data }) => updateRegistration(data))
                    .then(() => handleSuccessBase())
                    .catch(() => handleErrorBase())
                }
              />
            );
          }}
        />
      </div>
    );
  }
}

export default PathwaySummary;
